import { render, staticRenderFns } from "./ElementsQuestion.vue?vue&type=template&id=0b11ac64"
import script from "./ElementsQuestion.vue?vue&type=script&lang=js"
export * from "./ElementsQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports